module.exports = __webpack_public_path__ + "static/media/roboto-v27-latin-regular.dc3e086f.woff";